export default __webpack_public_path__ + "static/media/sweden-city.a6ca2430.jpeg";